import React, {useState} from "react";

import {Card, Col, Divider, Form, Input, InputNumber, Row} from 'antd';
import {ContainerForm, TextDivider} from "./styles";
import Vehicle from "../../models/Vehicle";

import {MailOutlined, PhoneOutlined} from '@ant-design/icons';
import AppParameters from "../../models/AppParameters";
import {MaskedInput} from "antd-mask-input";
import RegisterAddress from "../RegisterAddress";
import Address from "../../models/Address";
import {maskChassi} from "../../utils/StringUtils";

interface ConfirmDataProps {
    proprietaryName: string
    inserer: string
    vehicleData: Vehicle
    formRef: any
    appParameters: AppParameters
    cpfOrCnpj: number
}

const ConfirmData: React.FC<ConfirmDataProps> = ({
                                                     proprietaryName,
                                                     vehicleData,
                                                     formRef,
                                                     appParameters,
                                                     inserer,
                                                     cpfOrCnpj,
                                                     ...rest
                                                 }: ConfirmDataProps) => {
    const [address, setAddress] = useState<Address>(vehicleData.addressDto);

    const [phoneMask, setPhoneMask] = useState('000000000');

    //Máscara dinamica do campo telefone numero
    const onChangePhoneNumber = (e: any) => {
        let lengthValue = 0;
        if (e.inputType === 'insertText' || e.inputType === 'deleteContentBackward') {
            lengthValue = e.unmaskedValue.length <= 8 ? e.unmaskedValue.length : e.unmaskedValue.length + e.data.length
        } else if (e.type === "paste") {
            lengthValue = e.unmaskedValue.length;
        } else if (e.type === "keypress") {
            lengthValue = e.unmaskedValue.length < 8 ? e.unmaskedValue.length : e.unmaskedValue.length + e.key.length
        }
        lengthValue === 0 ? setPhoneMask('000000000') : lengthValue <= 8 ? setPhoneMask('0000-0000') : setPhoneMask('00000-0000')
    }

    return (
        <ContainerForm>

            <Divider orientation="center"
                     plain><TextDivider> {appParameters.company === 'Suhai' || inserer ? 'Dados do Segurado' : 'Dados do Proprietário'} </TextDivider></Divider>

            <Form form={formRef} layout="vertical">
                <Row gutter={{xs: 12, sm: 16, md: 24, lg: 32}}>
                    <Col className="gutter-row" xl={13} xs={24} sm={24}>
                        <Row gutter={{xs: 12, sm: 16, md: 24, lg: 32}}>
                            <Col className="gutter-row" xl={24} xs={24} sm={24}>
                                <Form.Item label="Nome">
                                    <Input value={proprietaryName} disabled={true}/>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={{xs: 24, sm: 16, md: 24, lg: 32}}>
                            <Col className="gutter-row" xl={12} xs={24} sm={12}>
                                <Form.Item label="Email" name="email"
                                           rules={[{required: true, message: 'Informe o email'}, {
                                               type: "email",
                                               message: 'Informe um email válido'
                                           }]}>
                                    <Input placeholder="exemplo@exemplo.com" addonBefore={<MailOutlined/>}/>
                                </Form.Item>
                            </Col>
                            <Col xl={4} xs={9} sm={4}>
                                <Form.Item name="contactDDD" label="DDD" rules={[{required: true, message: 'DDD'}]}>
                                    <InputNumber placeholder="DDD" min={11} max={99}/>
                                </Form.Item>
                            </Col>
                            <Col xl={8} xs={15} sm={8}>
                                <Form.Item name="contactNumber" label="Telefone"
                                           rules={[{required: true, message: 'Informe o telefone'}, {
                                               min: 8,
                                               message: 'Telefone inválido'
                                           }]}>
                                    <MaskedInput onChange={onChangePhoneNumber} mask={phoneMask}
                                                 maskOptions={{lazy: true}} addonBefore={<PhoneOutlined/>}
                                                 placeholder="Número"/>
                                </Form.Item>
                            </Col>

                        </Row>
                    </Col>

                    <Col className="gutter-row" xl={11} xs={24} sm={24}>
                        <Card style={{width: '100%', background: '#e2c636', height: 150, textAlign: 'center'}}>
                            <h3><strong>Atenção:</strong> Confira o e-mail e o celular informados, para sua comodidade,
                                os dados do agendamento serao enviados por e-mail e SMS.</h3>
                        </Card>
                    </Col>


                    {/* <Col className="gutter-row" xl={12} xs={24} >
                        <Card style={{ width: '100%', background: '#e2c636', marginBottom: '14px' }}>
                            <p><strong>Atenção:</strong> Confira o e-mail e o celular informados, para sua comodidade, os dados do agendamento serao enviados por e-mail e SMS.</p>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={{ xs: 12, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" xl={6} xs={24} sm={12}>
                        <Form.Item label="Email" name="email" rules={[{required: true, message: 'Informe o email'}, { type: "email", message: 'Informe um email válido' }]}>
                            <Input placeholder="exemplo@exemplo.com" addonBefore={<MailOutlined />} />
                        </Form.Item>
                    </Col>
                    <Col xl={2} xs={9} sm={4}>                                
                        <Form.Item name="contactDDD" label="DDD" rules={[{ required: true, message: 'DDD' }]}>
                            <InputNumber placeholder="DDD" min={11} max={99} />
                        </Form.Item>                                                                
                    </Col>
                    <Col xl={4} xs={15} sm={7}>                                
                        <Form.Item name="contactNumber" label="Telefone" rules={[{ required: true, message: 'Informe o telefone' }, {min: 8, message: 'Telefone inválido'}]}>
                            <MaskedInput onChange={onChangePhoneNumber} mask={phoneMask} maskOptions={{lazy: true}} addonBefore={<PhoneOutlined />} placeholder="Número" />
                        </Form.Item>                                                                
                    </Col>               */}

                    {/* </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}> */}
                    {/* <Col className="gutter-row" span={12} >
                        <Form.Item label="E-mail">
                            <Input value={"teste@teste.com.br"} disabled={true} />
                        </Form.Item>
                    </Col> */}
                    {/* </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}> */}
                    {/* <Col className="gutter-row" span={2}>
                        <Form.Item label="DDD">
                            <Input value={"011"} disabled={true} />
                        </Form.Item>
                    </Col> */}
                    {/* <Col className="gutter-row" span={4}>
                        <Form.Item label="Fixo">
                            <Input value={"1202-1212"} disabled={true} />
                        </Form.Item>
                    </Col> */}
                    {/* <Col className="gutter-row" span={2}>
                        <Form.Item label="DDD">
                            <Input value={"011"} disabled={true} />
                        </Form.Item>
                    </Col> */}
                    {/* <Col className="gutter-row" span={4}>
                        <Form.Item label="Celular">
                            <Input value={"1202-1212"} disabled={true} />
                        </Form.Item>
                    </Col> */}

                    {/* Confirmacao de dados */}
                    {/* <Col className="gutter-row" span={2}>
                        <Form.Item label="DDD">
                            <Input value={""} />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={4}>
                        <Form.Item label="Fixo">
                            <Input value={""} />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={2}>
                        <Form.Item label="DDD">
                            <Input value={""} />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={4}>
                        <Form.Item label="Celular">
                            <Input value={""} />
                        </Form.Item>
                    </Col> */}
                </Row>
                <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
                    <Col className="gutter-row" xl={24} xs={24}>
                        <Form.Item label="Endereço">
                            <Input
                                value={address &&
                                    address.address + ', ' +
                                    address.number +
                                    (address.complement ? ' - ' + address.complement : '') + ' - ' +
                                    address.county + ' - ' +
                                    address.city + '/' + address.state + ' - ' +
                                    address.zipCode}
                                disabled={true}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>


            <Divider orientation="center" plain><TextDivider> Dados Veiculo </TextDivider></Divider>

            <Form>
                <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
                    <Col className="gutter-row" xl={6} xs={24} sm={12}>
                        <Form.Item label="Placa">
                            <Input value={vehicleData.vehiclePlate} disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xl={6} xs={24} sm={12}>
                        <Form.Item label="Chassi">
                            <Input value={maskChassi(vehicleData.vehicleChassi)} disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xl={6} xs={24} sm={12}>
                        <Form.Item label="Fabricante">
                            <Input value={vehicleData.vehicleManufacturerName} disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xl={6} xs={24} sm={12}>
                        <Form.Item label="Modelo">
                            <Input value={vehicleData.vehicleModelName} disabled={true}/>
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
                    <Col className="gutter-row" xl={8} xs={12}>
                        <Form.Item label="Cor">
                            <Input value={vehicleData.vehicleColorName} disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xl={8} xs={12}>
                        <Form.Item label="Ano">
                            <Input value={vehicleData.vehicleYear} disabled={true}/>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xl={8} xs={24}>
                        <Form.Item label="Tipo">
                            <Input value={vehicleData.vehicleTypeName} disabled={true}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            <RegisterAddress cpfOrCnpj={cpfOrCnpj} formRef={formRef} vehicleData={vehicleData} setAddress={setAddress}
                             isInitialAddress={true}/>
        </ContainerForm>
    )
}

export default ConfirmData;
